import { ChartLegend } from '../../../../core/components/legend/categorical/ChartLegend.js';
import { LegendItem } from '../../../../core/components/legend/categorical/types/legend.js';
import { LegendSizeContext } from '../../../../core/components/legend/shared/context/LegendSizeContext.js';
import type { Dimensions } from '../../../../core/types/dimensions.js';

/**
 * @internal
 */
export interface MeterBarChartThresholdLegendProps {
  legendSize: Dimensions;
  data: LegendItem[];
}

/**
 * @internal
 */
export const MeterBarChartThresholdLegend = ({
  data,
  legendSize,
}: MeterBarChartThresholdLegendProps) => {
  return (
    <LegendSizeContext.Provider value={legendSize}>
      <ChartLegend
        items={data}
        interactionsDisabled
        style={{ height: '100%' }}
      />
    </LegendSizeContext.Provider>
  );
};

ChartLegend['displayName'] = 'MeterBarChartThresholdLegend';
